<section id="region-preguntas">
    <div class="page__content">
        <div class="card-group">
            <div class="card-body">
                <ul class="preguntas">
                    <li *ngFor="let faq of faQ">
                            <img class="icons-card" [src]="clientLoader.getAssetUrl('/assets/preguntas/' + faq.icono)" [alt]="faq.titleKey ? (faq.titleKey | translate) : faq.titulo" />
                            <h3 class="card-title">{{ faq.titleKey ? (faq.titleKey | translate) : faq.titulo }}</h3>
                            <p *ngIf="faq.descriptionKey" class="card-text">{{ faq.descriptionKey | translate }}</p>
                            <p *ngIf="!faq.descriptionKey" [innerHTML]="faq.descripcion" class="card-text"></p>
                    </li>
                </ul>
            </div>
        </div>
        <div class="mis-tramites">
            <h2>{{ 'HOME.REGISTER_CTA.TITLE' | translate }}</h2>
            <p>{{ 'HOME.REGISTER_CTA.TEXT' | translate }}</p>
        </div>
    </div>
</section>